import { SWRFetcher } from '@commenda/utils';
import { Country, Currency } from '@prisma/client';
import useSWR, { KeyedMutator } from 'swr';
import { BASE_URL, IMarketplaceServicesItem, ListItemsQueryDTO } from './types';

export function useMarketplaceServiceList({
  country,
  searchQuery,
  offset,
  limit,
  type,
  sortBy,
}: ListItemsQueryDTO): {
  data?: {
    items: IMarketplaceServicesItem[];
    totalItems: number;
    nextOffset?: string;
    servicesCountByCountry: { [key in Country]: number };
  };
  error?: unknown;
  mutate: KeyedMutator<any>;
} {
  const queryParams = new URLSearchParams();
  if (country) queryParams.append('country', country);
  if (searchQuery) queryParams.append('searchQuery', searchQuery);
  if (offset) queryParams.append('offset', offset.toString());
  if (limit) queryParams.append('limit', limit.toString());
  if (type) queryParams.append('type', type);
  if (sortBy) queryParams.append('sortBy', sortBy);
  queryParams.append('currencyCode', Currency.USD);

  const { data, error, mutate } = useSWR<{
    items: IMarketplaceServicesItem[];
    totalItems: number;
    nextOffset?: string;
    servicesCountByCountry: { [key in Country]: number };
  }>(
    `${BASE_URL}/services?${queryParams.toString()}`,
    SWRFetcher({
      method: 'GET',
    })
  );

  return { data: data, error, mutate };
}
